export const yMetricGroups = [
  { key: "ttft", label: "Time To First Token" },
  { key: "itl", label: "Inter Token Latency" },
  { key: "ttlt", label: "Time To Last Token" },
];

export const yMetricAggregates = [
  // { key: "mean", label: "Mean" },
  { key: "p50", label: "Median" },
  { key: "p90", label: "p90" },
  { key: "p95", label: "p95" },
];

export const columnGroups = {
  configuration: [
    "framework",
    "model",
    "gpu_type",
    "gpu_count",
    "task",
    "prompt_tokens",
    "generated_tokens",
    "tokens",
    "total_tokens",
    "cli_args",
    "env_vars",
    "kwargs",
  ],
  metrics: [
    "queries_per_second",
    "ttft_mean",
    "ttft_p50",
    "ttft_p90",
    "ttft_p95",
    "itl_mean",
    "itl_p50",
    "itl_p90",
    "itl_p95",
    "ttlt_mean",
    "ttlt_p50",
    "ttlt_p90",
    "ttlt_p95",
  ],
} as const;

export const displayColumns = [
  {
    keys: ["framework"],
    label: "Framework",
    value: (row: { framework: string }) => row.framework,
  },
  {
    keys: ["model"],
    label: "Model",
    value: (row: { model: string }) => `${row.model}`,
  },
  {
    keys: ["gpu_type", "gpu_count"],
    label: "GPU",
    value: (row: { gpu_type: string; gpu_count: number }) =>
      `${row.gpu_count} × ${row.gpu_type}`,
  },
  {
    keys: ["task", "prompt_tokens", "generated_tokens", "total_tokens"],
    label: "Task",
    value: (row: { task: string }) => row.task,
  },
  {
    keys: ["cli_args"],
    label: "CLI Args",
    value: (row: { cli_args: string | null }) => row.cli_args ?? "–",
    onlyTooltip: true,
  },
  {
    keys: ["env_vars"],
    label: "Env Vars",
    value: (row: { env_vars: string | null }) => row.env_vars ?? "–",
    onlyTooltip: true,
  },
  {
    keys: ["kwargs"],
    label: "kwargs",
    value: (row: { kwargs: string | null }) => row.kwargs ?? "–",
    onlyTooltip: true,
  },
] as const;

export type DisplayColumnNames = (typeof displayColumns)[number]["label"];
